import React from "react";
import { APP_CONNECT_STATUS } from "../../constants/AppConstants";
import { DotNormalSvg, DotFailureSvg, DotUnlinkedSvg } from "../Assets";

export default function ConnectStatus({ status, className }) {
  const checkStatus = (status) => {
    switch (status) {
      case APP_CONNECT_STATUS.Normal:
        return {
          name: "정상",
          img: DotNormalSvg,
          className: "normal"
        };
      case APP_CONNECT_STATUS.Failure:
        return {
          name: "실패",
          img: DotFailureSvg,
          className: "failure"
        };
      default:
        return {
          name: "미연동",
          img: DotUnlinkedSvg,
          className: "unlinked"
        };
    }
  };

  return (
    <div className={`connect-status flex align-middle gap-1 ${checkStatus(status).className}`}>
      <div className="flex items-center">
        <img src={checkStatus(status).img} />
      </div>
      <span className="text-xs flex items-center justify-center">
        {checkStatus(status).name}
      </span>
    </div>
  );
}
